import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userId: "",
  userName: "",
  rows: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
};

const callLogsDetailsSlice = createSlice({
  name: "callLogsDetails",
  initialState,

  reducers: {
    saveCallLogsDetails(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },

    clearCallLogsDetails() {
      return initialState;
    },
  },
});

export const {
  saveCallLogsDetails,
  clearCallLogsDetails,
} = callLogsDetailsSlice.actions;

export default callLogsDetailsSlice.reducer;